import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './AboutPage.css';
import meaganHeadshot from '../images/meagan-kuhl-headshot.webp';

const AboutPage = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto',
    });
  }, []);

  const preparePlannerScroll = () => {
    sessionStorage.setItem('scrollTarget', 'planner');
  };

  return (
    <main className="about-page">
      <section className="about-hero">
        <div className="about-hero-copy">
          <p className="about-eyebrow">About Office Outing</p>

          <h1>Better team experiences start with a better way to plan.</h1>

          <p>
            Office Outing helps busy managers, HR teams, and executive
            assistants find and plan better experiences for their teams.
          </p>

          <p>
            From outings and volunteer events to trainings, speakers, and
            company retreats, we make it easier to discover options that fit
            your location, group size, budget, and goals.
          </p>
        </div>

        <div className="about-hero-card">
          <span>Our mission</span>

          <strong>Outdo the Conference Room.</strong>

          <p>
            Give teams a simpler way to discover, compare, and plan experiences
            that bring people together.
          </p>
        </div>
      </section>

      <section className="about-founder-section">
       <div className="about-founder-visual">
  <img
    src={meaganHeadshot}
    alt="Meagan Kuhl, founder of Office Outing"
    className="about-founder-photo"
  />
</div>

        <div className="about-founder-copy">
          <p className="about-eyebrow">Meet the Founder</p>

          <h2>Built from real event-planning experience.</h2>

          <p>
            Office Outing was founded by <strong>Meagan Kuhl</strong>, an
            experienced event planner who served on the campus events committee
            at Colorado State University, where she helped lead large-scale
            events with hundreds of attendees.
          </p>

          <p>
            She has also planned events professionally, giving her firsthand
            experience with event logistics, vendor coordination, timelines,
            budgets, and the many details required to bring a successful event
            together.  Her previous work as an inside sales engineer for a commercial HVAC
  company also gave her business-to-business sales experience and further
  strengthened her project-management and client-communication skills.
          </p>

          <p>
            Meagan created Office Outing to make company event planning faster
            and less overwhelming. Her goal is to help managers, HR teams, and
            executive assistants discover strong options for their teams
            without spending hours searching scattered websites or coordinating
            every detail on their own.
          </p>
    <p>
              In 2023, Office Outing was selected as one of three winners of the Casper Start-Up Challenge,
                providing early validation for its approach to simplifying company event planning.
               </p>

          <div className="about-founder-highlights">
            <span>Colorado State University events committee</span>
            <span>Large events with hundreds of attendees</span>
            <span>Professional event-planning experience</span>
                <span>2023 Casper Start-Up Challenge Winner</span>
        </div>
              </div>
      </section>

      <section className="about-story-section">
        <div className="about-section-heading">
          <p className="about-eyebrow">Why Office Outing Exists</p>
          <h2>Planning should not begin with hours of searching.</h2>
        </div>

        <div className="about-story-grid">
          <article className="about-info-card">
            <span className="about-card-number">01</span>

            <h3>A better starting point</h3>

            <p>
              Planning something for a team often sounds simple until you begin
              comparing venues, activities, group limits, pricing,
              availability, and logistics across dozens of websites.
            </p>
          </article>

          <article className="about-info-card">
            <span className="about-card-number">02</span>

            <h3>Options for every kind of team</h3>

            <ul>
              <li>Team outings and activities</li>
              <li>Trainings and workshops</li>
              <li>Speakers and keynotes</li>
              <li>Company retreats and off-sites</li>
              <li>Volunteer opportunities</li>
            </ul>
          </article>

          <article className="about-info-card">
            <span className="about-card-number">03</span>

            <h3>More than a directory</h3>

            <p>
              Office Outing helps teams narrow their choices, request
              personalized recommendations, and receive planning support when
              they need help comparing options or coordinating details.
            </p>
          </article>
        </div>
      </section>

      <section className="about-how-section">
        <div className="about-section-heading">
          <p className="about-eyebrow">How It Works</p>
          <h2>From an early idea to a plan that works.</h2>
        </div>

        <div className="about-steps">
          <article className="about-step">
            <span>1</span>

            <div>
              <h3>Find your match</h3>

              <p>
                Choose what you are planning and narrow the options by
                location, group size, budget, setting, and goals.
              </p>
            </div>
          </article>

          <article className="about-step">
            <span>2</span>

            <div>
              <h3>Request personalized ideas</h3>

              <p>
                Tell us more about your team and receive three tailored
                recommendations reviewed by a real person.
              </p>
            </div>
          </article>

          <article className="about-step">
            <span>3</span>

            <div>
              <h3>Get planning support</h3>

              <p>
                Office Outing can help with research, vendor communication,
                timelines, comparisons, and event coordination.
              </p>
            </div>
          </article>
        </div>
      </section>

      <section className="about-location-section">
        <div>
          <p className="about-eyebrow">Where We’re Starting</p>
          <h2>Local knowledge with room to grow.</h2>
        </div>

        <p>
          Office Outing is currently building its collection of team
          experiences in <strong>Casper, Wyoming</strong>, and{' '}
          <strong>Denver, Colorado</strong>, with plans to expand into
          additional cities.
        </p>
      </section>

      <section className="about-cta-section">
        <p className="about-eyebrow">Start Planning</p>

        <h2>Ready to find something better for your team?</h2>

        <p>
          Browse curated options or get personalized help planning the details.
        </p>

       <div className="about-actions">
  <Link
    to="/personalized-ideas"
    className="about-button about-button-primary"
  >
    Find Your Match
  </Link>

  <Link
    to="/planning-assistance"
    className="about-button about-button-secondary"
  >
    Get Planning Assistance
  </Link>
</div>
      </section>
    </main>
  );
};

export default AboutPage;
